import { ForgotPasswordScreen } from "@/features/auth";

export default ForgotPasswordScreen;
